 
 import React from 'react';
 import '../styles/Contact.css';
 
 function Contact() {
   return (
     <div className="contact-page">
       <div className="contact-container">
         <div className="contact-header">
           <h1>Get In Touch</h1>
           <p>We'd love to hear from you! Reach out with any questions about our events, membership, or blockchain topics.</p>
         </div>
 
         <div className="contact-info">
           <div className="contact-method">
             <div className="icon-circle">
               <i className="fas fa-envelope"></i>
             </div>
             <h3>Email Us</h3>
             <p>The best way to reach us is by email:</p>
             <a href="mailto:blockchaingroup@u.northwestern.edu" className="email-link">blockchaingroup@u.northwestern.edu</a>
             <p className="response-time">We typically respond within 24-48 hours</p>
           </div>
 
           <div className="contact-method">
             <div className="icon-circle">
               <i className="fas fa-comments"></i>
             </div>
             <h3>Join Our Community</h3>
             <p>For quick questions and to connect with our members:</p>
             <a 
               href="https://discord.gg/w6tUfpUMHn" 
               target="_blank" 
               rel="noopener noreferrer"
               className="discord-button"
             >
               <i className="fab fa-discord"></i>
               Join Discord
             </a>
           </div>
 
           
         </div>
 
         <div className="contact-cta">
           <h3>Want to stay updated?</h3>
           <p>Follow us on social media for the latest news and events.</p>
           <div className="social-mini-buttons">
             <a 
               href="https://www.linkedin.com/company/nu-blockchain-group" 
               target="_blank" 
               rel="noopener noreferrer"
             >
               <i className="fab fa-linkedin"></i>
             </a>
             <a 
               href="https://instagram.com/nublockchain" 
               target="_blank" 
               rel="noopener noreferrer"
             >
               <i className="fab fa-instagram"></i>
             </a>
           </div>
         </div>
       </div>
     </div>
   );
 }
 
 export default Contact;